window.CaseStudiesShowcase = () => {
    return {
        caseStudyOpened: false,
        videoSource: '',
        videoType: '',
    };
};